import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgRenderExternalComponent } from './svg-render-external.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ SvgRenderExternalComponent ],
    declarations: [ SvgRenderExternalComponent ],
})
export class SvgRenderExternalModule {}
